<template>
  <div id="ag-grid-demo">
    <vx-card>
      <data-table
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :row-data="reportdata"
        :total="total"
        pagination
        :current-page="currentPage"
        :pagination-page-size="pageSize"
        :reset-current-page-flag="resetCurrentPageFlag"
        @update:reset-current-page-flag="resetCurrentPageFlag = false"
        @update:current-page="onUpdateCurrentPage"
        @update:pagination-page-size="onUpdatePaginationPageSize"
        @sort-changed="onSortChange"
      >
        <template #actions>
          <vs-button
            class="mb-4 md:mb-0 mr-4"
            @click="onCSVExportClick"
          >
            CSVエクスポート
          </vs-button>
          <DateRanges
            :start-day="startDay"
            :end-day="endDay"
            @on-change="onDateChange"
          />
        </template>
      </data-table>
    </vx-card>
  </div>
</template>

<script>
import moment from 'moment'
import DateRanges from '@/components/DateRanges'
import DataTable from '@/components/table/DataTable'
import {mapActions} from 'vuex'

export default {
  name: 'ByDay',
  components: {
    DataTable,
    DateRanges
  },
  data () {
    return {
      sortParam: '',
      currentPage: 1,
      total: 0,
      pageSize: 20,
      resetCurrentPageFlag: false,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: false,
        suppressMenu: true
      },
      columnDefs: [
        { headerName: '日', field: 'date', width: 175, pinned: 'left' },
        { headerName: '商品売上', field: 'sales' },
        { headerName: '配送料金', field: 'shippingCharge' },
        { headerName: '配送手数料', field: 'shippingChargeback' },
        { headerName: 'ギフト包装料金', field: 'giftwrap' },
        { headerName: 'ギフト包装手数料', field: 'giftwrapChargeback' },
        { headerName: '総売上', field: 'totalSales' },
        { headerName: 'FBA出荷手数料', field: 'fbaFulfillmentFee' },
        { headerName: '販売手数料', field: 'commission' },
        { headerName: 'プロモーション料金（旧：2022年6月30日まで）', field: 'promotion' },
        { headerName: 'クーポン', field: 'promotionCoupon' },
        { headerName: '定期購買', field: 'promotionSubscribe' },
        { headerName: '無料配送', field: 'promotionShipping' },
        { headerName: 'プロモーション', field: 'promotionOther' },
        { headerName: 'amazonポイント', field: 'pointsGranted' },
        { headerName: '商品原価', field: 'cost' },
        { headerName: '返金', field: 'refund' },
        { headerName: '補填', field: 'adjustment' },
        { headerName: 'FBA保管手数料', field: 'fbaStorageFee' },
        { headerName: 'FBA長期在庫保管手数料', field: 'fbaLongTermStorageFee' },
        { headerName: '月額登録料', field: 'subscription' },
        { headerName: '取引手数料', field: 'dealFee' },
        { headerName: 'クーポン支払い', field: 'couponPayment' },
        { headerName: '広告費', field: 'adCost' },
        { headerName: '広告経由売上', field: 'adSales' },
        { headerName: '自然売上', field: 'naturalSales' },
        { headerName: '利益', field: 'profit' },
        { headerName: '総費用', field: 'totalCost' }
      ]
    }
  },
  computed: {
    reportdata: {
      get () {
        return this.$store.getters['report/dayData']
      }
    },
    startDay: {
      get () {
        return this.$store.state.startDay
      }
    },
    endDay: {
      get () {
        return this.$store.state.endDay
      }
    }
  },
  mounted () {
    this.getReport()
  },
  methods: {
    ...mapActions('report', ['downloadCSV', 'getDay']),
    async getReport () {
      const payload = {
        start_day: this.startDay.split('T')[0],
        end_day: this.endDay.split('T')[0],
        page: this.currentPage,
        per_page: this.pageSize,
        sort: this.sortParam
      }
      try {
        const res = await this.getDay(payload)
        this.total = res.data.total
      } catch (e) {
        console.log(e)
      }
    },
    onUpdateCurrentPage (val) {
      this.currentPage = val
      this.getReport()
    },
    onUpdatePaginationPageSize (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getReport()
    },
    onDateChange (date) {
      this.$store.commit('SET_STARTDAY', moment(date.start).format())
      this.$store.commit('SET_ENDDAY',  moment(date.end).format())
      this.currentPage = 1
      this.resetCurrentPageFlag = true
      this.getReport()
    },
    onSortChange (e) {
      const sortModel = e.columnApi.getColumnState().find(s => s.sort != null)
      if (sortModel) {
        const sortParam = `${sortModel.colId}-${sortModel.sort}`
        if (this.sortParam !== sortParam) {
          this.currentPage = 1
        }
        this.sortParam = sortParam
        this.getReport()
      }
    },
    async onCSVExportClick () {
      const payload = {
        start_day: this.startDay.split('T')[0],
        end_day: this.endDay.split('T')[0],
        sort: this.sortParam,
        action: 'day'
      }
      try {
        await this.downloadCSV(payload)
      } catch (e) {
        console.log(e)
      }
    }
  }
}

</script>

<style>
.holamundo .vs-popup {
  width: 700px;
}
</style>
